import { useWxSDK } from "@/hooks/useWxSDK";
import { getWXJSSdkConfig } from "@/api/config";
import { Local } from "@/utils/storage";
export function useWxShare(url, shareConfig) {
  const { initConfig, setShareInfo } = useWxSDK();
  getWXJSSdkConfig({ url: url }).then(({ ret, data }) => {
    initConfig(data).then(() => {
      setShareInfo({
        ...shareConfig,
      });
    });
  });
}
